import {Component, Injector} from '@angular/core';
import {PlayerContainer} from '../../player/player.container';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, finalize, tap} from "rxjs/operators";

@Component({
  selector: 'app-collection',
  template: '<div #component><template #playercontainer></template></div>',
  styleUrls: []
})
export class CollectionComponent extends PlayerContainer {
  pages: any;
  index: number;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(playerObject.$.label, this.PREVIEW);
          return of(null);
        }
        this.loadStat();
        this.pages = this.data.Collection[0].Page;
        this.index = 0;
        return this.showPage();
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  getPage(): Observable<any> {
    if (this.data==null) {
      return of(null);
    }
    if (this.pages==null || this.pages.length==0) {
      return of(null);
    }
    const page = this.pages[this.index];
    let player = page.Player[0];
    return of(player);
  }


  onCommand(command, param): Observable<any> {
    if (this.pages.length==0) {
      return of(null);
    }
    let pageName;
    let index;
    const cmd = command.$.command;
    switch (cmd) {
      case 'command': // ???  test only, to be deleted
        this.index++;
        if (this.index >= this.pages.length) {
          this.index = 0;
        }
        break;

      case 'firstPage':
        this.index=0;
        break;

      case 'prevPage':
        this.index--;
        if (this.index<0) {
          this.index = this.pages.length-1;
        }
        break;

      case 'nextPage':
        this.index++;
        if (this.index >= this.pages.length) {
          this.index = 0;
        }
        break;

      case 'lastPage':
        this.index = this.pages.length-1;
        break;

      case 'selectPage':
        pageName = command.Params[0].Page[0].$.name;
        index = 0;
        this.pages.forEach(page => {
          if (page.$.page == pageName) {
            this.index = index;
          }
          index++;
        })
        break;

      case 'paramPage':
        pageName = param;
        if (pageName==null)
          return;
        index = 0;
        this.pages.forEach(page => {
          if (page.$.page == pageName) {
            this.index = index;
          }
          index++;
        })
        break;

      default:
        alert(cmd);
        break;
    }
    return this.showPage();
  }


  destroy(): void {
    super.destroy();
  }
}
